<template>
  <div class="header_index_nav top">
    <div class="sticky-wrapper" style="height: auto;"></div>
    <header>
      <div class="index_nav">
        <div class="nav_box">
          <div class="nav_flex">
            <div class="nav_logo_w" @click="toHome"></div>
            <div class="nav_li">
              <div class="nav_li_text" @click="headerClick('aboutus')">{{ $t('nav.aboutUs') }}</div>
              <div class="nav_li_text" @click="headerClick('society')">{{ $t('nav.society') }}</div>
              <div class="nav_li_text" @click="headerClick('news')">{{ $t('nav.news') }}</div>
              <div class="nav_li_text" @click="headerClick('InvestorRelations')">{{ $t('nav.investor') }}</div>
              <div class="nav_li_text" @click="headerClick('joinus')">{{ $t('nav.joinUs') }}</div>
            </div>
            <language-switcher @lang-change="onLangChange"></language-switcher>
          </div>
        </div>
      </div>
      <!--移动端导航-->
      <div class="mobile_index_nav">
        <div class="nav_logo_w" @click="toHome"></div>
        <div :class="{ menuline: true, menulineactive: showMobileTitle }" @click="navClick">
          <div class="middleline"></div> 
        </div>
      </div>
      <transition name="mobile-nav">
        <div class="mobile_open_nav" v-show="showMobileTitle">
          <div class="m_open_logo">
            <div class="nav_logo_w"></div>
            <div :class="{ menuline: true, menulineactive: showMobileTitle }" @click="navClick">
              <div class="middleline"></div> 
            </div>
          </div>
          <div class="m_open_list">
            <div class="m_list_text" @click="headerClick('aboutus')">{{ $t('nav.aboutUs') }}</div>
            <div class="m_list_text" @click="headerClick('society')">{{ $t('nav.society') }}</div>
            <div class="m_list_text" @click="headerClick('news')">{{ $t('nav.news') }}</div>
            <div class="m_list_text" @click="headerClick('InvestorRelations')">{{ $t('nav.investor') }}</div>
            <div class="m_list_text" @click="headerClick('joinus')">{{ $t('nav.joinUs') }}</div>
          </div>
          <language-switcher @lang-change="onLangChange"></language-switcher>
        </div>
      </transition>
    </header>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import store from '../../../store'
import LanguageSwitcher from './LanguageSwitcher.vue'

export default {
  name: 'navagateOther',
  components: {
    LanguageSwitcher
  },
  props: {},
  data () {
    return {
      showMobileTitle: false
    }
  },
  computed: {
    ...mapState("global", ["navigatorInfo", "currentTap"]),
  },
  methods: {
    ...mapActions("global", ["ActionSetCurrentTap"]),
    navClick() {
      this.showMobileTitle = !this.showMobileTitle
    },
    toHome() {
      this.$router.push('/')
    },
    headerClick(name) {
      this.showMobileTitle = false
      if (name === 'aboutus') {
        this.$router.push('/aboutus')
      } else if (name === 'society') {
        this.$router.push('/society')
      } else if (name === 'news') {
        this.$router.push('/news')
      } else if (name === 'InvestorRelations') {
        this.$router.push('/InvestorRelations')
      } else if (name === 'joinus') {
        this.$router.push('/joinus')
      }
    },
    onLangChange(lang) {
      console.log('Language changed to:', lang)
      // 向父组件传递语言切换事件
      this.$emit('lang-change', lang)
    }
  }
}
</script>
